import { useQuery } from "@tanstack/react-query";
import { activitiesServices } from "./activities.service";
import { ACTIVITIES_KEYS } from "./activities.keys";
import { GetActivitiesParams } from "./activities.type";

export const useGetActivities = (params?: GetActivitiesParams) => {
  return useQuery({
    queryKey: ACTIVITIES_KEYS.list(params),
    queryFn: () => activitiesServices.getActivities(params),
  });
};

export const useGetRecentActivities = (limit?: number) => {
  return useQuery({
    queryKey: ACTIVITIES_KEYS.recent(limit),
    queryFn: () => activitiesServices.getRecentActivities(limit),
  });
};
